import { Box, ListItem } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useStopwatch } from "react-timer-hook";

import { Viewer } from "@/utilities/types/viewer";

import useStyles from "./LiveUnitViewersItem.styles";


export interface LiveUnitViewerItemProps {
  /**
   * Information about the current viewer
   */
  viewer: Viewer;
}

export const LiveUnitViewersItem: React.FC<LiveUnitViewerItemProps> = ({ viewer }) => {
  const { t } = useTranslation("translation", { keyPrefix: "components.liveUnitMosaicPage.liveUnitViewers" });

  const styles = useStyles();

  const getDuration = () => {
    const duration = Date.now() - new Date(viewer.joined).valueOf();

    return new Date(Date.now() + duration);
  };

  const { hours, minutes, seconds } = useStopwatch({ autoStart: true, offsetTimestamp: getDuration() });

  return (
      <ListItem disableGutters className={styles.listItem}>
          <Box display="flex" flexDirection="column" width="100%">
              <Box display="flex" justifyContent="space-between" alignItems="baseline">
                  <Box display="flex" paddingRight={4}>
                      <strong>{viewer.name}</strong>
                      <div className={styles.secondaryText}>
                          <Box paddingX={1}>&#124;</Box>
                          <div data-testid="viewer-time">{`${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`}</div>
                      </div>
                  </Box>
                  {viewer.viewOnlyAccess
                ? <div className={styles.viewOnly}>{t("accessTag.viewOnly")}</div>
                : <div className={styles.cameraAccess}>{t("accessTag.cameraControl")}</div>
            }
              </Box>
              <div className={styles.secondaryText}>{viewer.username}</div>
          </Box>
      </ListItem>
  );
};
